import { render, staticRenderFns } from "./ManejoComprobantesInternos.vue?vue&type=template&id=95988d2e&scoped=true"
import script from "./ManejoComprobantesInternos.vue?vue&type=script&lang=js"
export * from "./ManejoComprobantesInternos.vue?vue&type=script&lang=js"
import style0 from "./ManejoComprobantesInternos.vue?vue&type=style&index=0&id=95988d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95988d2e",
  null
  
)

export default component.exports